import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import TextField from 'modules/core/components/TextField'
import { useEffect, useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { Country } from 'modules/legal_entities/lib/constants'
import idValidationStrategies from 'modules/legal_entities/lib/identifierValidators'
import getMaxLengthByCountryAndIdType from 'modules/legal_entities/lib/identifierValidators/fieldLength'
import { ItalyIdType } from 'modules/legal_entities/lib/identifierValidators/italy/idType'
import getPlaceholderByCountryAndIdType from 'modules/legal_entities/lib/identifierValidators/placeholders'
import useIdentifierForm from 'modules/payroll_employees/hooks/useIdentifierForm'
import { SupportedCountry } from 'modules/payroll_employees/lib/enums'

const COUNTRY = SupportedCountry.Italy
const TAX_ID_LABEL = 'Codice Fiscale'

interface Props {
  employeeId: number
  mandatory: boolean
  readonly: boolean
  setSubmitEventHandler: (eventHandler: () => void) => void
  setIdentifiersDirty: (dirty: boolean) => void
  setIdentifiersError?: (error: boolean) => void
}

const Italy = ({
  employeeId,
  mandatory,
  readonly,
  setSubmitEventHandler,
  setIdentifiersDirty,
  setIdentifiersError,
}: Props) => {
  const form = useIdentifierForm({
    employeeId: employeeId,
    country: COUNTRY,
    setSubmitEventHandler,
  })

  const [taxId, setTaxId] = React.useState(form.get('tax_id').value)
  useUnsafeEffect(() => {
    setTaxId(form.get('tax_id').value)
  }, [form])
  const handleTaxIdChange = (x: string) => {
    setTaxId(x)
    form.setValues({ ...form.values, tax_id: x })
    setIdentifiersDirty(form.isDirty)
  }

  const taxIdError = idValidationStrategies(
    Country.Italy as Country,
    'tax_id' as ItalyIdType,
    form.get('tax_id').value,
    TAX_ID_LABEL
  ).errors()

  useEffect(() => {
    if (setIdentifiersError) setIdentifiersError(!!taxIdError)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxIdError])

  return (
    <Box gap="s24" width="full">
      <TextField
        mandatory={mandatory}
        readonly={readonly}
        label={TAX_ID_LABEL}
        value={taxId}
        onChange={handleTaxIdChange}
        placeholder={getPlaceholderByCountryAndIdType(
          Country.Italy as Country,
          'tax_id' as ItalyIdType
        )}
        error={taxIdError}
        maxLength={getMaxLengthByCountryAndIdType(
          Country.Italy as Country,
          'tax_id' as ItalyIdType
        )}
      />
    </Box>
  )
}

export default React.memo(Italy)
